import React, { useEffect, useState } from 'react';
import { API } from 'api/api';

interface Payment {
  Id: number;
  Created: string;
  State: string;
  Value: string;
  Description: string;
  PaymentMethodName: string;
  PaymentMethodId: number;
  OfficeOrCompanyName: string;
  PaymentLink?: string;
}

export const Payments: React.FC = () => {
  const [payments, setPayments] = useState<Payment[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchPayments = async () => {
    try {
      setLoading(true);
      const response = await API.Payments.get();
      const paymentsData = response.data.Payments || [];
      // Sort by date from newest to oldest
      const sortedPayments = paymentsData.sort((a: Payment, b: Payment) => 
        new Date(b.Created).getTime() - new Date(a.Created).getTime()
      );
      setPayments(sortedPayments);
    } catch (err) {
      console.error('Error fetching payments:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments();
  }, []);

  const formatDate = (dateString: string) => {
    try {
      return new Date(dateString).toLocaleDateString('ru-RU');
    } catch {
      return dateString;
    }
  };

  const getDisplayDescription = (payment: Payment) => {
    if (payment.PaymentMethodId === 3) {
      return 'Оплата за следующий месяц обучения — октябрь';
    }
    return payment.Description;
  };


  if (loading) {
    return <div>Загрузка...</div>;
  }

  return (
    <div style={{ padding: '20px' }}>
      <h2>Платежи</h2>

      {payments.length === 0 ? (
        <div>Платежи не найдены</div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ backgroundColor: '#f8f9fa' }}>
              <th style={{ padding: '10px', border: '1px solid #ddd' }}>Дата</th>
              <th style={{ padding: '10px', border: '1px solid #ddd' }}>Сумма</th>
              <th style={{ padding: '10px', border: '1px solid #ddd' }}>Описание</th>
              <th style={{ padding: '10px', border: '1px solid #ddd' }}>Статус</th>
              <th style={{ padding: '10px', border: '1px solid #ddd' }}>Действия</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((payment) => (
              <tr key={payment.Id}>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                  {formatDate(payment.Created)}
                </td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                  {payment.Value}
                </td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                  {getDisplayDescription(payment)}
                </td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                  <span
                    style={{
                      padding: '4px 8px',
                      borderRadius: '4px',
                      color: 'white',
                      backgroundColor:
                        payment.State.toLowerCase() === 'paid' ? 'green' : 'red',
                    }}
                  >
                    {payment.State.toLowerCase() === 'paid' ? 'Оплачен' : 'Не оплачен'}
                  </span>
                </td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                  {payment.State.toLowerCase() === 'unpaid' && payment.PaymentLink && (
                    <div>
                      <a
                        href={payment.PaymentLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          display: 'inline-block',
                          padding: '5px 10px',
                          margin: '2px',
                          backgroundColor: 'red',
                          color: 'white',
                          textDecoration: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer',
                        }}
                      >
                        Оплатить
                      </a>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
